import { useState, useEffect } from "react";
import { sbListarCuentas, sbActualizarEstadoCuenta } from '../services/superadmin';

// ── SUPERADMIN: gestión de cuentas del plan FREE (self-service) ──
export const MasterCuentasSection = () => {
  const [cuentas, setCuentas] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState("");

  const [confirmToggle, setConfirmToggle] = useState(null);
  const [toggleLoadingId, setToggleLoadingId] = useState(null);
  const [errorToggle, setErrorToggle] = useState("");

  const cargar = async () => {
    setLoading(true);
    setError("");
    try {
      const data = await sbListarCuentas();
      setCuentas(data.cuentas || []);
    } catch (e) {
      setError(e.message || "Error al cargar cuentas.");
    }
    setLoading(false);
  };

  useEffect(() => { cargar(); }, []);

  const pedirConfirmacionToggle = (cuenta) => { setConfirmToggle(cuenta); setErrorToggle(""); };

  const confirmarToggle = async () => {
    const cuenta = confirmToggle;
    const activar = cuenta.baneado;
    setToggleLoadingId(cuenta.id);
    setErrorToggle("");
    try {
      await sbActualizarEstadoCuenta(cuenta.id, activar ? "activar" : "desactivar");
      setConfirmToggle(null);
      cargar();
    } catch (e) {
      setErrorToggle(e.message || "Error al cambiar el estado de la cuenta.");
    }
    setToggleLoadingId(null);
  };

  return (
    <div className="space-y-4">
      <div className="flex items-center justify-between">
        <h2 className="font-bold text-gray-800 text-lg">Cuentas FREE (self-service)</h2>
      </div>

      {loading && <p className="text-sm text-gray-500">Cargando...</p>}
      {error && <p className="text-sm text-red-600 font-semibold">{error}</p>}

      {!loading && !error && (
        <div className="bg-white rounded-xl shadow overflow-hidden">
          <table className="w-full text-sm">
            <thead className="bg-gray-50 text-gray-500 text-xs uppercase">
              <tr>
                <th className="text-left px-4 py-2">Empresa</th>
                <th className="text-left px-4 py-2">Email</th>
                <th className="text-left px-4 py-2">Plan</th>
                <th className="text-left px-4 py-2">Estado</th>
                <th className="text-left px-4 py-2">Fecha de alta</th>
                <th className="text-left px-4 py-2">Descargas</th>
                <th className="text-left px-4 py-2">Logo</th>
                <th className="text-right px-4 py-2">Acción</th>
              </tr>
            </thead>
            <tbody className="divide-y">
              {cuentas.map(c => (
                <tr key={c.id} className={c.baneado ? "opacity-60" : ""}>
                  <td className="px-4 py-3 font-semibold text-gray-800">{c.nombre_empresa || "—"}</td>
                  <td className="px-4 py-3 text-gray-600">{c.email || "—"}</td>
                  <td className="px-4 py-3 text-gray-600">{c.plan || "free"}</td>
                  <td className="px-4 py-3">
                    <span className={`text-xs font-bold px-2 py-1 rounded-full ${c.baneado ? "bg-red-100 text-red-700" : "bg-green-100 text-green-700"}`}>{c.baneado ? "Inactivo" : "Activo"}</span>
                  </td>
                  <td className="px-4 py-3 text-gray-600">{c.created_at ? new Date(c.created_at).toLocaleDateString("es-ES") : "—"}</td>
                  <td className="px-4 py-3 text-gray-600">{c.descargas_mes_actual ?? 0}/40</td>
                  <td className="px-4 py-3">
                    {c.logo_url ? <img src={c.logo_url} alt="Logo" className="w-8 h-8 object-contain rounded border" /> : <span className="text-gray-300">—</span>}
                  </td>
                  <td className="px-4 py-3 text-right">
                    <button onClick={() => pedirConfirmacionToggle(c)} disabled={toggleLoadingId === c.id} className={`text-xs font-bold disabled:opacity-40 ${c.baneado ? "text-green-600 hover:text-green-800" : "text-red-600 hover:text-red-800"}`}>
                      {toggleLoadingId === c.id ? "..." : c.baneado ? "Reactivar" : "Desactivar"}
                    </button>
                  </td>
                </tr>
              ))}
              {cuentas.length === 0 && (
                <tr><td colSpan={8} className="px-4 py-6 text-center text-gray-400">No hay cuentas FREE todavía.</td></tr>
              )}
            </tbody>
          </table>
        </div>
      )}

      {confirmToggle && (
        <div className="fixed inset-0 bg-black/40 flex items-center justify-center z-50 p-4">
          <div className="bg-white rounded-xl shadow-xl w-full max-w-sm p-5 space-y-3">
            <h3 className="font-bold text-gray-800">{confirmToggle.baneado ? "Reactivar cuenta" : "Desactivar cuenta"}</h3>
            <p className="text-sm text-gray-600">
              {confirmToggle.baneado
                ? <>¿Reactivar <strong>{confirmToggle.nombre_empresa || confirmToggle.email}</strong>? Podrá volver a iniciar sesión.</>
                : <>¿Desactivar <strong>{confirmToggle.nombre_empresa || confirmToggle.email}</strong>? Se bloqueará su cuenta y no podrá iniciar sesión hasta que la reactives.</>}
            </p>
            {errorToggle && <p className="text-xs text-red-600 font-semibold">{errorToggle}</p>}
            <div className="flex gap-2 pt-2">
              <button onClick={() => setConfirmToggle(null)} className="flex-1 bg-gray-100 text-gray-700 font-bold py-2 rounded-xl hover:bg-gray-200">Cancelar</button>
              <button onClick={confirmarToggle} disabled={toggleLoadingId === confirmToggle.id} className={`flex-1 text-white font-bold py-2 rounded-xl disabled:opacity-40 ${confirmToggle.baneado ? "bg-green-600 hover:bg-green-700" : "bg-red-600 hover:bg-red-700"}`}>
                {toggleLoadingId === confirmToggle.id ? "Guardando..." : confirmToggle.baneado ? "Reactivar" : "Desactivar"}
              </button>
            </div>
          </div>
        </div>
      )}
    </div>
  );
};
